import * as actionTypes from './actionTypes';
import { ViewSentEmailRequestPayload, ResendMessageRequestPayload, ResponsePayload } from './types';

export const fetchSentMessageRequest = (payload: ViewSentEmailRequestPayload) => ({
  type: actionTypes.FETCH_SENT_MESSAGE_REQUEST,
  payload,
});

export const fetchSentMessageError = () => ({
  type: actionTypes.FETCH_SENT_MESSAGE_ERROR,
});

export const fetchSentMessageResponse = (response: ResponsePayload) => ({
  type: actionTypes.FETCH_SENT_MESSAGE_RESPONSE,
  response,
});

export const resendMessageRequest = (
  payload: ResendMessageRequestPayload,
  campaignName: string,
) => ({
  type: actionTypes.RESEND_MESSAGE_REQUEST,
  payload,
  campaignName,
});
